import {createSelector} from 'reselect';

import type {SimpleProductType} from 'constants/flow/flowTypesProduct';
import type {ApplicationStoreType} from 'constants/flow/flowTypes';

import {isProperty} from 'libs/utils/utils';
import {getActiveChildrenProductId} from 'selectors/product/product';

/**
 * Has upsells
 *
 * @param {ApplicationStoreType} store - application store
 * @return {boolean} does store has upsells
 */
export const isUpsellEmpty = (store: ApplicationStoreType): boolean =>
    store.upsell.status === 'fulfilled' && store.upsell.data.length === 0;

/**
 * Get a list of upsell products
 * @param {ApplicationStoreType} store application
 * @returns {Array<SimpleProductType>} upsell products list
 */
export const getUpsellList = (store: ApplicationStoreType): Array<SimpleProductType> =>
    store.upsell.data;

/**
 * Get is upsell item fulfilled.
 *
 * @param {ApplicationStoreType} - Application store.
 * @returns {boolean} - is upsell items fulfilled.
 */
export const isUpsellItemsFulfilled = isProperty('upsell.status', 'fulfilled');

/**
 * Get upsell items withoud active product
 *
 * @param {ApplicationStoreType} - Application store.
 * @returns {Array<SimpleProductType>} - upsell items
 */
export const getUpsellWithoutActiveProduct = createSelector(
    getUpsellList,
    getActiveChildrenProductId,
    (products, activeProductId) => products.filter(product => product.id !== activeProductId),
);
